<template>
	<div class="content-button">
		<button
			:href="url"
			:class="[className, size, $i18n.locale]"
			:target="target"
			:rel="setRelOnTarget()"
			:data-hover="!hover ? title : hover"
			@click="donate"
			id="donateButton"
		>
			<span>{{ title }}</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'Button',
	props: {
		title: { type: String },
		url: { type: String, default: '#' },
		target: { type: String, default: '_self' },
		size: { type: String, default: '' },
		hover: { type: String, default: null },
		className: { type: String, default: 'btn' },
	},
	methods: {
		setRelOnTarget() {
			return this.target === '_blank' ? 'noopener noreferrer' : ''
		},
		donate() {
			window.fbq('track', 'PageView')
			window.open(this.url, '_blank')
		},
	},
}
</script>

<style scoped lang="scss">
.content-button {
	text-align: center;
}

@include nomobile {
	button {
		&:hover {
			cursor: pointer;
		}
	}
}
</style>
